import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.support.announcement.editor');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

interface FormField {
    id: string;
    type: 'text' | 'textarea' | 'number' | 'date' | 'email' | 'tel' | 'url' | 'select' | 'radio' | 'checkbox' | 'file' | 'section';
    label: string;
    description?: string;
    placeholder?: string;
    required?: boolean;
    options?: string[];        // select/radio/checkbox
    accept?: string;           // file
    maxSize?: number;          // file (bytes)
    multiple?: boolean;        // file/checkbox
}

@Component({
    selector: 'wiz-portal-lpsysadmin-support-announcement-editor',
template: templateSource || '',
    styles: [``],
})
export class PortalLpsysadminSupportAnnouncementEditorComponent implements OnInit {
    @Input() program_id: string = '';
    @Input() announcement_id: string = '';   // 'new' or actual id

    constructor(@Inject( Service) public service: Service) { }

    public loaded: boolean = false;
    public saving: boolean = false;
    public isNew: boolean = false;
    public tab: string = 'info';   // info | company | builder | settings | preview

    public model: any = {
        id: '',
        program_id: '',
        slug: '',
        title: '',
        description: '',
        contact_name: '',
        contact_email: '',
        contact_phone: '',
        apply_start: '',
        apply_end: '',
        status: 'draft',
        form_schema: { fields: [] as FormField[] },
        settings: {
            allow_edit: false,           // 제출 후 수정 허용
            send_email: true,            // 접수 완료 메일 발송
            success_message: '신청이 접수되었습니다. 접수번호는 등록한 이메일로 발송됩니다.',
            company: { fields: [] as any[], custom: [] as FormField[] },
        },
    };

    // 기업 정보 기본 항목 (관리자가 사용/필수 토글 가능, locked=true 는 항상 사용·필수)
    public DEFAULT_COMPANY_FIELDS = [
        { key: 'company_name',    label: '기업명',          inputType: 'text',     enabled: true, required: true,  locked: true },
        { key: 'registed_number', label: '사업자등록번호',  inputType: 'text',     enabled: true, required: false, locked: false, placeholder: '000-00-00000' },
        { key: 'business_area',   label: '사업분야',        inputType: 'text',     enabled: true, required: false, locked: false },
        { key: 'ceo_name',        label: '대표자명',        inputType: 'text',     enabled: true, required: true,  locked: false },
        { key: 'ceo_phone',       label: '연락처',          inputType: 'tel',      enabled: true, required: true,  locked: false, placeholder: '010-0000-0000' },
        { key: 'ceo_email',       label: '이메일',          inputType: 'email',    enabled: true, required: true,  locked: true, hint: '접수번호와 결과 안내가 발송됩니다' },
        { key: 'employee_count',  label: '임직원 수',       inputType: 'number',   enabled: true, required: false, locked: false },
        { key: 'revenue',         label: '전년 매출 (원)',  inputType: 'number',   enabled: true, required: false, locked: false },
        { key: 'summary',         label: '사업 요약',       inputType: 'textarea', enabled: true, required: false, locked: false },
    ];

    // 폼 빌더
    public selectedField: FormField | null = null;
    public fieldTypes = [
        { type: 'text', label: '단답형', icon: 'T' },
        { type: 'textarea', label: '장문형', icon: '¶' },
        { type: 'number', label: '숫자', icon: '#' },
        { type: 'email', label: '이메일', icon: '@' },
        { type: 'tel', label: '전화번호', icon: '☎' },
        { type: 'date', label: '날짜', icon: '📅' },
        { type: 'select', label: '드롭다운', icon: '▾' },
        { type: 'radio', label: '단일선택', icon: '◉' },
        { type: 'checkbox', label: '다중선택', icon: '☑' },
        { type: 'file', label: '파일 업로드', icon: '📎' },
        { type: 'section', label: '섹션 구분', icon: '—' },
    ];

    public statusOptions = [
        { value: 'draft', label: '작성중 (비공개)' },
        { value: 'open', label: '게시 (접수 시작)' },
        { value: 'closed', label: '마감' },
        { value: 'archived', label: '보관' },
    ];

    public publicUrl: string = '';

    public async ngOnInit() {
        await this.service.init();
        this.isNew = (!this.announcement_id || this.announcement_id === 'new');
        if (this.isNew) {
            this.model.program_id = this.program_id;
            this._normalizeCompanySettings();
            this.loaded = true;
            await this.service.render();
        } else {
            await this.load();
        }
    }

    public async load() {
        const { code, data } = await wiz.call('get', { id: this.announcement_id });
        if (code === 200 && data) {
            this.model = Object.assign(this.model, data);
            if (!this.model.form_schema || !this.model.form_schema.fields) {
                this.model.form_schema = { fields: [] };
            }
            if (!this.model.settings) {
                this.model.settings = { allow_edit: false, send_email: true, success_message: '' };
            }
            this._normalizeCompanySettings();
            this.publicUrl = window.location.origin + '/apply/f/' + this.model.slug;
        }
        this.loaded = true;
        await this.service.render();
    }

    private _normalizeCompanySettings() {
        if (!this.model.settings.company) {
            this.model.settings.company = { fields: [], custom: [] };
        }
        const c = this.model.settings.company;
        if (!Array.isArray(c.fields)) c.fields = [];
        if (!Array.isArray(c.custom)) c.custom = [];
        // 기본 필드 보정 (신규 추가된 default 키도 자동 합류)
        const byKey: any = {};
        for (const f of c.fields) byKey[f.key] = f;
        const merged: any[] = [];
        for (const def of this.DEFAULT_COMPANY_FIELDS) {
            const exist = byKey[def.key];
            const item = exist ? { ...def, ...exist, locked: def.locked, inputType: def.inputType } : { ...def };
            if (item.locked) { item.enabled = true; item.required = true; }
            merged.push(item);
        }
        c.fields = merged;
    }

    public async save() {
        if (!this.model.title || !this.model.title.trim()) {
            await this.service.alert.show({ title: '제목 필요', message: '공고 제목을 입력하세요.', action: '확인', actionBtn: 'primary' });
            return;
        }
        this.saving = true;
        await this.service.render();
        const payload: any = {
            title: this.model.title,
            description: this.model.description,
            contact_name: this.model.contact_name,
            contact_email: this.model.contact_email,
            contact_phone: this.model.contact_phone,
            apply_start: this.model.apply_start || null,
            apply_end: this.model.apply_end || null,
            status: this.model.status,
            form_schema: this.model.form_schema,
            settings: this.model.settings,
            slug: this.model.slug,
        };
        let res;
        if (this.isNew) {
            payload.program_id = this.program_id;
            res = await wiz.call('create', { data: JSON.stringify(payload) });
        } else {
            res = await wiz.call('update', { id: this.announcement_id, data: JSON.stringify(payload) });
        }
        this.saving = false;
        if (res.code !== 200) {
            await this.service.alert.show({ title: '저장 실패', message: res.message || '오류', action: '확인', actionBtn: 'error' });
            await this.service.render();
            return;
        }
        if (this.isNew) {
            // 새로 생성된 ID로 라우팅 갱신
            const newId = res.data.id;
            this.service.href(`/admin/support/programs/${this.program_id}/announcements/${newId}`);
            return;
        }
        await this.service.alert.show({ title: '저장 완료', message: '저장되었습니다.', action: '확인', actionBtn: 'primary' });
        await this.load();
    }

    public goBack() {
        if (this.program_id) {
            this.service.href(`/admin/support/programs/${this.program_id}/announcements`);
        } else {
            this.service.href('/admin/support/programs');
        }
    }

    public async copyUrl() {
        if (!this.publicUrl) return;
        try {
            await navigator.clipboard.writeText(this.publicUrl);
            await this.service.alert.show({ title: '복사 완료', message: this.publicUrl, action: '확인', actionBtn: 'primary' });
        } catch (e) {
            await this.service.alert.show({ title: '복사 실패', message: this.publicUrl, action: '확인', actionBtn: 'primary' });
        }
    }

    // ------------------------------------------------------------------
    // 폼 빌더
    // ------------------------------------------------------------------
    private _newId(): string {
        return 'f_' + Math.random().toString(36).slice(2, 10);
    }

    public async addField(type: string) {
        const field: FormField = {
            id: this._newId(),
            type: type as any,
            label: this._defaultLabel(type),
            required: false,
        };
        if (type === 'select' || type === 'radio' || type === 'checkbox') {
            field.options = ['항목 1', '항목 2'];
        }
        if (type === 'file') {
            field.accept = '';
            field.maxSize = 10 * 1024 * 1024;
        }
        this.model.form_schema.fields.push(field);
        this.selectedField = field;
        await this.service.render();
    }

    private _defaultLabel(type: string): string {
        const map: any = {
            text: '단답형 질문', textarea: '장문형 질문', number: '숫자', email: '이메일',
            tel: '전화번호', date: '날짜', select: '드롭다운', radio: '단일 선택',
            checkbox: '다중 선택', file: '파일 첨부', section: '섹션 제목',
        };
        return map[type] || '질문';
    }

    public async selectField(f: FormField) {
        this.selectedField = f;
        await this.service.render();
    }

    public async removeField(idx: number) {
        const ok = await this.service.alert.show({
            title: '필드 삭제', message: '이 필드를 삭제하시겠습니까?',
            action: '삭제', actionBtn: 'error', cancel: '취소',
        });
        if (!ok) return;
        const removed = this.model.form_schema.fields.splice(idx, 1)[0];
        if (this.selectedField === removed) this.selectedField = null;
        await this.service.render();
    }

    public async moveField(idx: number, dir: -1 | 1) {
        const arr = this.model.form_schema.fields;
        const j = idx + dir;
        if (j < 0 || j >= arr.length) return;
        [arr[idx], arr[j]] = [arr[j], arr[idx]];
        await this.service.render();
    }

    public async duplicateField(idx: number) {
        const arr = this.model.form_schema.fields;
        const orig = arr[idx];
        const copy: FormField = JSON.parse(JSON.stringify(orig));
        copy.id = this._newId();
        copy.label = orig.label + ' (복사)';
        arr.splice(idx + 1, 0, copy);
        await this.service.render();
    }

    public async addOption(field: FormField) {
        if (!field.options) field.options = [];
        field.options.push(`항목 ${field.options.length + 1}`);
        await this.service.render();
    }

    public async removeOption(field: FormField, idx: number) {
        if (!field.options) return;
        field.options.splice(idx, 1);
        await this.service.render();
    }

    public trackField = (i: number, f: FormField) => f.id;
    public trackOption = (i: number) => i;

    public fieldTypeLabel(type: string): string {
        const t = this.fieldTypes.find(x => x.type === type);
        return t ? t.label : type;
    }

    // ------------------------------------------------------------------
    // 기업 정보 (Company Info) 항목 관리
    // ------------------------------------------------------------------
    public async toggleCompanyEnabled(f: any) {
        if (f.locked) return;
        f.enabled = !f.enabled;
        if (!f.enabled) f.required = false;
        await this.service.render();
    }

    public async toggleCompanyRequired(f: any) {
        if (f.locked) return;
        if (!f.enabled) return;
        f.required = !f.required;
        await this.service.render();
    }

    public async moveCompanyField(idx: number, dir: -1 | 1) {
        const arr = this.model.settings.company.fields;
        const j = idx + dir;
        if (j < 0 || j >= arr.length) return;
        [arr[idx], arr[j]] = [arr[j], arr[idx]];
        await this.service.render();
    }

    public selectedCompanyCustom: FormField | null = null;

    public async addCompanyCustomField(type: string) {
        const field: FormField = {
            id: this._newId(),
            type: type as any,
            label: this._defaultLabel(type),
            required: false,
        };
        if (type === 'select' || type === 'radio' || type === 'checkbox') {
            field.options = ['항목 1', '항목 2'];
        }
        if (type === 'file') {
            field.accept = '';
            field.maxSize = 10 * 1024 * 1024;
        }
        this.model.settings.company.custom.push(field);
        this.selectedCompanyCustom = field;
        await this.service.render();
    }

    public async selectCompanyCustom(f: FormField) {
        this.selectedCompanyCustom = f;
        await this.service.render();
    }

    public async removeCompanyCustom(idx: number) {
        const ok = await this.service.alert.show({
            title: '항목 삭제', message: '이 기업 정보 항목을 삭제하시겠습니까?',
            action: '삭제', actionBtn: 'error', cancel: '취소',
        });
        if (!ok) return;
        const removed = this.model.settings.company.custom.splice(idx, 1)[0];
        if (this.selectedCompanyCustom === removed) this.selectedCompanyCustom = null;
        await this.service.render();
    }

    public async moveCompanyCustom(idx: number, dir: -1 | 1) {
        const arr = this.model.settings.company.custom;
        const j = idx + dir;
        if (j < 0 || j >= arr.length) return;
        [arr[idx], arr[j]] = [arr[j], arr[idx]];
        await this.service.render();
    }

    // ------------------------------------------------------------------
    // 신청서 미리보기 헬퍼
    // ------------------------------------------------------------------
    public previewCompanyFields(): any[] {
        const fields = (this.model.settings && this.model.settings.company && this.model.settings.company.fields) || [];
        return fields.filter((f: any) => f.enabled);
    }

    public previewCompanyCustom(): any[] {
        return (this.model.settings && this.model.settings.company && this.model.settings.company.custom) || [];
    }
}

export default PortalLpsysadminSupportAnnouncementEditorComponent;